'use client';

import { useCallback } from 'react';
import { useStandardTrack } from './useStandardTrack';

export type TrackElementInteractedArgs = {
  component: string;
  /** event_id from the paired Element Viewed (required for CTR). */
  impressionId: string;
  extraAttributes?: Record<string, unknown>;
  interactionType?: string;
};

export type UseNWAElementInteractedResult = {
  trackElementInteracted: (args: TrackElementInteractedArgs) => Promise<void>;
};

export function useNWAElementInteracted(): UseNWAElementInteractedResult {
  const track = useStandardTrack();

  const trackElementInteracted = useCallback(
    async ({
      component,
      impressionId,
      extraAttributes,
      interactionType,
    }: TrackElementInteractedArgs) => {
      await track('Element Interacted', {
        entity_name: component,
        parent_event_id: impressionId,
        ...(interactionType ? { interaction_type: interactionType } : {}),
        ...(extraAttributes ? { additional_attributes: extraAttributes } : {}),
      });
    },
    [track],
  );

  return { trackElementInteracted };
}
